export enum ApplianceType {
  GASBOILER = 'GASBOILER',
}

export enum PropertyOwner {
  HOMEOWNER = 'HOMEOWNER',
  LANDLORD = 'LANDLORD',
}

export enum PropertyType {
  FLAT = 'Flat',
  HOUSE = 'House',
  DOMESTIC = 'DOMESTIC',
  GUESTHOUSE = 'GUESTHOUSE',
}

export enum Require {
  INSURANCE = 'INSURANCE',
  ABS = 'ABS',
}

export enum BoilerBrand {
  ALPHA = 'Alpha',
  ARISTON = 'Ariston',
  ATAG = 'ATAG',
  BAXI_POTTERTON = 'Baxi Potterton',
  BG = 'British Gas',
  GLOWWORM = 'Glow Worm',
  IDEAL = 'Ideal',
  INTERGAS = 'Intergas',
  MAIN = 'Main',
  PRO = 'Pro Combi boilers',
  REMEHA = 'Remeha',
  VAILLANT = 'Vaillant',
  VIESSMANN = 'Viessman',
  VOKERA = 'Vokera',
  WORCESTER = 'Worcester',
  OTHER = 'other',
  DEFAULT = 'default',
}

export enum BoilerModel {
  VALID = 'valid',
}

export interface IAppliance {
  age: number;
  id: string;
  manufacturer: BoilerBrand;
  model: string;
  type: ApplianceType;
  isunder45kw: boolean;
  naturalmainsgas: boolean;
  singleboiler: boolean;
  needsrepair: boolean;
}

export enum DocumentType {
  IPID = 'IPID',
  TERMS = 'TERMS',
  PRIVACY = 'PRIVACY',
  DISTANCE_MARKETING = 'DISTANCE_MARKETING',
}

export interface IDocument {
  type: DocumentType;
  url: string;
}

enum PolicyCode {
  GAS_ESSENTIALS = 'GAS_ESSENTIALS',
  GAS_STARTER = 'GAS_STARTER',
  GAS_COMPLETE = 'GAS_COMPLETE',
}

export enum PolicyComponent {
  ANNUAL_BOILER_SERVICE = 'ANNUAL_BOILER_SERVICE',
  PRIORITY_HELPLINE = 'PRIORITY_HELPLINE',
  CENTRAL_HEATING = 'CENTRAL_HEATING',
  GAS_BOILER = 'GAS_BOILER',
  PLUMBING_ELECTRICS = 'PLUMBING_ELECTRICS',
  INTERNAL_DRAINS = 'INTERNAL_DRAINS',
  WATER_SUPPLY = 'WATER_SUPPLY',
  GAS_SUPPLY = 'GAS_SUPPLY',
  GAS_BOILER_REPLACEMENT = 'GAS_BOILER_REPLACEMENT',
  EXTERNAL_DRAINS = 'EXTERNAL_DRAINS',
  TAPS_TOILETS = 'TAPS_TOILETS',
}

export enum PolicyExclusion {
  FIRST_MONTH = 'FIRST_MONTH',
  PRE_EXISTING = 'PRE_EXISTING',
  UNDERFLOOR_HEATING = 'UNDERFLOOR_HEATING',
  FIRST_THREE_MONTHS = 'FIRST_THREE_MONTHS',
  WEATHER = 'WEATHER',
  OLD_BOILERS = 'OLD_BOILERS',
  NO_EARLY_REPLACEMENT = 'NO_EARLY_REPLACEMENT',
  EXCESS = 'EXCESS',
  DEBRIS_DAMAGE = 'DEBRIS_DAMAGE',
  DISCONNECTION = 'DISCONNECTION',
  ELECTRICAL_DEVICES = 'ELECTRICAL_DEVICES',
  LANDLORDS = 'LANDLORDS',
  OUTSIDE_WATER = 'OUTSIDE_WATER',
  SHARED_DRAINS = 'SHARED_DRAINS',
  COMMERCIAL_BOILERS = 'COMMERCIAL_BOILERS',
  STEEL_PIPES_WITH_PLUMBING = 'STEEL_PIPES_WITH_PLUMBING',
  STEEL_PIPES = 'STEEL_PIPES',
  ELECTRICAL_FAULTS = 'ELECTRICAL_FAULTS',
  LIGHTING = 'LIGHTING',
  PITCH_FIBRE_DRAINS = 'PITCH_FIBRE_DRAINS',
  BEYOND_REPAIR = 'BEYOND_REPAIR',
  UNOCCUPIED = 'UNOCCUPIED',
}

export interface IPolicy {
  code: PolicyCode;
  components: PolicyComponent[];
  excess: number[];
  exclusions: PolicyExclusion[];
  singleappliance: boolean;
  version: string;
}

export enum ProductCode {
  ESSENTIALS = 'ESSENTIALS',
  STARTER = 'STARTER',
  COMPLETE = 'COMPLETE',
  HOME_RECOVER_COMPLETE = 'HOME_RECOVER_COMPLETE',
  ABS = 'ABS',
  EV_CHARGER_COVER = 'EV_CHARGER',
  EPD_COVER = 'ELECTRICS_PLUMBING_AND_DRAINAGE',
}

export enum ProductCategory {
  NONINSURANCE = 'NONINSURANCE',
  INSURANCE = 'INSURANCE',
}

export enum ProductName {
  ESSENTIALS = 'Essentials',
  STARTER = 'Starter',
  COMPLETE = 'Complete',
  HOME_RECOVER = 'Home Recover',
  ANNUAL_BOILER_SERVICE = 'Annual Boiler Service',
  EV_CHARGER_COVER = 'EV Charger',
  EPD_COVER = 'Electrics, Plumbing and Drainage',
}

export enum ProductDetailCode {
  ABS = 'ABS',
  GASBOILER_REPAIR = 'GASBOILER_REPAIR',
  ESSENTIALS = 'ESSENTIALS',
  STARTER = 'STARTER',
  COMPLETE = 'COMPLETE',
}

enum ProductPaymentType {
  DIRECTDEBIT = 'DIRECTDEBIT',
  CARDPAYMENT = 'CARDPAYMENT',
}

enum ProductType {
  STANDALONE = 'STANDALONE',
  SERVICE = 'SERVICE',
}

interface IProductDetail {
  category: ProductCategory;
  code: ProductDetailCode;
  paymenttype: ProductPaymentType;
  type: ProductType;
  policy?: {
    code: PolicyCode;
  };
}

export interface IProduct {
  category: ProductCategory;
  code: ProductCode;
  composition: ProductDetailCode[];
  details: IProductDetail[];
  durations: number[];
  name: ProductName;
}

export enum OfferType {
  FIXED_DISCOUNT = 'FIXED_DISCOUNT',
  FIXED_PRICE = 'FIXED_PRICE',
  VOUCHER = 'VOUCHER',
  PERCENTAGE_DISCOUNT = 'PERCENTAGE_DISCOUNT',
  MTA = 'MTA',
}

export enum OfferPromotionCode {
  HALF_PRICE_8M = 'HALF_PRICE_8M',
  FREE_4M = 'FREE_4M',
  FREE_6M = 'FREE_6M',
  ABS1_RESELL = 'ABS1_RESELL',
  HALF_PRICE = 'HALF_PRICE',
  ABS2_BEYOND = 'ABS2_BEYOND',
  FREE = 'FREE',
  HALF_PRICE_6M = 'HALF_PRICE_6M',
  FIXED_120_24M = 'FIXED_120_24M',
  FREE_3M = 'FREE_3M',
  HALF_PRICE_12M = 'HALF_PRICE_12M',
}

export enum OfferCode {
  Q4_2023_EXT = '2023_Q4_EXT',
  BFRIDAY_2023_EXT = 'BFRIDAY_2023_EXT',
  RESELL_ABS = 'RESELL_ABS',
  Q1_2024_ABS = '2024_Q1_ABS',
  BEYOND_ABS = 'BEYOND_ABS',
  RETAIN_ABS = 'RETAIN_ABS',
  HMB_FREE_ABS = 'HMB_FREE_ABS',
  OEHM_FREE_ABS = 'OEHM_FREE_ABS',
  RETAIN_OVO = 'RETAIN_OVO',
  HMB_HALF_PRICE = 'HMB_HALF_PRICE',
  RETAIN_CORGI = 'RETAIN_CORGI',
  MTA = 'MTA',
  FIX_PROTECT = 'FIX_PROTECT',
  Q3_2024_ABS_REFIX = '2024_Q3_ABS_REFIX',
  OSP_FREE_ABS = 'OSP_FREE_ABS',
  CHH_36_ABS = 'CHH_36_ABS',
  BFRIDAY_2023 = 'BFRIDAY_2023',
  Q4_2023_CORGI = '2023_Q4_CORGI',
  Q4_2023_OVO = '2023_Q4_OVO',
  Q1_2024_PROMO = '2024_Q1_PROMO',
  Q1_2024_OVO = '2024_Q1_OVO',
  Q1_2024_CORGI = '2024_Q1_CORGI',
  Q2_2024_ABS = '2024_Q2_ABS',
  OCT_FS_2024_OVO = 'OCT_FS_2024_OVO',
  BFRIDAY_2024_OVO = 'BFRIDAY_2024_OVO',
  Q4_2024_OVO_TARGETED = '2024_Q4_OVO_TARGETED',
  Q4_2024_OVO = '2024_Q4_OVO',
  FS1_2024_Q2_CORGI = 'FS1_2024_Q2_CORGI',
  FS2_2024_Q4_CORGI = 'FS2_2024_Q4_CORGI',
  FS3_2024_Q4_CORGI = 'FS3_2024_Q4_CORGI',
  FS4_2024_Q4_CORGI = 'FS4_2024_Q4_CORGI',
  OVO_Q1_2025_FS = 'OVO_Q1_2025_FS',
  OVO_Q1_2025_TARGETED = 'OVO_Q1_2025_TARGETED',
  OVO_Q1_2025_HEADLINE = 'OVO_Q1_2025_HEADLINE',
  CORGI_Q1_2025_FS1 = 'CORGI_Q1_2025_FS1',
  CORGI_Q1_2025_FS2 = 'CORGI_Q1_2025_FS2',
  CORGI_Q1_2025_FS3 = 'CORGI_Q1_2025_FS3',
  Q1_2025_EVCHARGER = '2025_Q1_EVCHARGER',
}

export enum ExcessAmountValue {
  ZERO = 0,
  FIFTY = 50,
  SIXTY = 60,
  THIRTY = 30,
  NINETY = 90,
  NINETY_FIVE = 95,
}

export interface IOffer {
  code: OfferCode;
  promocode?: string;
  enddate: string;
  promotion: OfferPromotionCode;
  type: OfferType;
}

export interface IPrice {
  cardpayment?: { full: number };
  contract: {
    full: number;
    monthly: number;
    totalinsurance: number;
    totalnoninsurance: number;
  };
  discount: {
    full: number;
    monthly: number;
    totalinsurance: number;
    totalnoninsurance: number;
  };
  headline: {
    full: number;
    monthly: number;
    totalinsurance: number;
    totalnoninsurance: number;
  };
  premium: {
    full: number;
    monthly: number;
  };
  promotion: {
    duration: number;
  };
  standard: {
    full: number;
    monthly: number;
    totalinsurance: number;
    totalnoninsurance: number;
  };
  version: string;
}

export interface IQuote {
  appliances: string[];
  duration: number;
  excess: number;
  offer?: IOffer;
  price: IPrice;
  product: ProductCode;
}

export interface IQuotesWrapper {
  appliances: string[];
  documents: IDocument[];
  policies: IPolicy[];
  product: IProduct;
  quotes: IQuote[];
}

export interface IQuoteNotEligible {
  appliance: IAppliance;
  eligiblerewardtypes: string[];
  noteligible: Record<string, string>;
  products: string[];
  promocode: string;
}

export interface IProperty {
  type: PropertyType;
  owner: PropertyOwner;
}

export type GetQuotesOptions = {
  applianceId: string;
  applianceType: ApplianceType;
  isAgent?: boolean;
  boilerAge?: string | number;
  boilerMake?: BoilerBrand;
  boilerModel?: BoilerModel;
  isHomeRecover?: boolean;
  isLandlord?: boolean;
  isGuestHouse?: boolean;
  isAbs?: boolean;
  promoCode?: string;
  isCreditEligible?: boolean;
  isLoggedIn?: boolean;
};

export type DefaultGetQuotesOptions = Omit<
  GetQuotesOptions,
  'applianceId' | 'applianceType'
>;

export type GetQuotesAppliance = {
  id: string;
  age: number;
  manufacturer: string;
  model: string;
  type: ApplianceType;
  isUnder45kw: boolean;
  naturalMainsGas: boolean;
  singleBoiler: boolean;
  needsRepair: boolean;
};

export type GetQuotesResponse = {
  result: IQuotesWrapper[];
  noteligible: IQuoteNotEligible[];
};

export type GetQuotesRequestBody = {
  appliances: GetQuotesAppliance[];
  property: IProperty;
  requires: Require[];
  eligibleRewardTypes: string[];
};
